import "./projects-style.scss";
import PLAYNETIC from "../../images/playnetic.webp";
import ON_SHOP from "../../images/OnShop.webp";
import PREVIEW from "../../images/preview.webp";
import FIN_TRACKER from "../../images/FinTracker.png";
import { useLanguage } from "../../hooks/useLanguage";
import GH_BOX_ICON from "../../images/github-boxicon.webp"
import { motion, Variants } from "framer-motion";

export const Projects = () => {
  const { translations: t } = useLanguage();
  /* const DEVS = t.projects.devs; */
  const GAMES = t.projects.games;
  const TITLES = t.projects.titles;

  const linkGitHub = (url:string) => {
    if (url) {
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.click();
    }
  };

  const itemVariants: Variants = {
    hidden: { opacity: 0, y: 50 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { 
        duration: 0.6, 
        ease: "easeOut" 
      } 
    }
  };

  const imageProjects = (image: number) => {
    switch (image) {
      case 0: return PLAYNETIC;
      case 1: return ON_SHOP;
      case 2: return FIN_TRACKER;
      default: return undefined;
    }
  };

  return (
    <div className="projects_container">
      <div className="projects_header">
        <motion.h1 
          className="title"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          {t.projects.title}
        </motion.h1>
        <motion.p 
          className="description"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          viewport={{ once: true }}
        >
          {t.projects.description}
        </motion.p>
      </div>
      
      <div className="games_section">
        <h2 className="section_title">
          <span className="title_accent"></span>
          {TITLES}
        </h2>
        <div className="projects_list">
          {GAMES.map((text, index) => (
            <motion.div 
              key={index} 
              className="project_item"
              variants={itemVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
            >
              <div className="project_image_wrapper">
                <img className="project_image" src={imageProjects(text.image)} alt={text.title} />
                <div className="image_glow"></div>
              </div>
              <div className="project_content">
                <h3 className="project_title">{text.title}</h3>
                <p className="project_description">{text.description}</p>
                <div className="project_actions">
                  {text.link && (
                    <button className="action_button primary" onClick={() => linkGitHub(text.link)}>
                      <img className="button_icon" src={GH_BOX_ICON} alt={text.title_link}/>
                      <span>{text.title_link}</span>
                    </button>
                  )}
                  <button 
                    className={`action_button secondary ${!text.link_preview ? 'disabled' : ''}`} 
                    onClick={() => text.link_preview && linkGitHub(text.link_preview)}
                    disabled={!text.link_preview}
                    style={!text.link_preview ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                  >
                    <img className="button_icon" src={PREVIEW} alt={text.preview || "Preview"}/>
                    <span>{text.preview || "Preview"}</span>
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      
      {/* <div className="other_projects">
        <h2 className="section_title">
          <span className="title_accent"></span>
          {TITLES.devs}
        </h2>
        <div className="projects_list">
          {DEVS.map((text, index) => (
            <motion.div 
              key={index} 
              className="project_item"
              variants={itemVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
            >
              <div className="project_image_wrapper">
                <img className="project_image" src={GAME_EDU} alt={text.title} />
                <div className="image_glow"></div>
              </div>
              <div className="project_content">
                <h3 className="project_title">{text.title}</h3>
                <p className="project_description">{text.description}</p>
                <div className="project_actions">
                  {text.link && (
                    <button className="action_button primary" onClick={() => linkGitHub(text.link)}>
                      <img className="button_icon" src={GH_BOX_ICON} alt={text.title_link}/>
                      <span>{text.title_link}</span>
                    </button>
                  )}
                  <button 
                    className={`action_button secondary ${!text.link_preview ? 'disabled' : ''}`} 
                    onClick={() => text.link_preview && linkGitHub(text.link_preview)}
                    disabled={!text.link_preview}
                    style={!text.link_preview ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                  >
                    <img className="button_icon" src={PREVIEW} alt={text.preview || "Preview"}/>
                    <span>{text.preview || "Preview"}</span>
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div> */}
    </div>
  );
};
